
import { Component, Prop, Vue } from 'vue-property-decorator';
import api from '@/api';
import Swal from 'sweetalert2';
import ItemForm from './Form.vue';

const { otherPoint } = api;

@Component({
  components: { ItemForm },
})
export default class OtherPointActivityCreate extends Vue {
  @Prop() private id!: string;

  private loading: boolean = false;

  private async submit(form: any) {
    if (form) {
      this.loading = true;
      const { status } = await otherPoint.activityCreate(this.id, form);
      this.loading = false;
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: '新增成功' });
        await this.$router.back();
      }
    }
  }
}
